import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layoutChange/layout";
import { Button } from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ModalPop from "components/sales/modal/modal";
import Images from "assets/images/imageData";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { toast } from "react-toastify";

const CreateHsn = ({ getGstList, createDeleteHsn, gstList = [], history }) => {
  const { baseUrl } = useContext(BaseUrl);

  const [hsnName, setHsnName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedGst, setSelectedGst] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getGstList();
      setIsLoading(false);
    })();
  }, [getGstList]);

  const handleSubmit = async () => {
    if (!hsnName || selectedGst.length === 0 || !selectedType) {
      toast.error("Please fill all details");
      return;
    }

    setIsLoading(true);

    const data = {
      name: hsnName,
      gst_id: selectedGst.id,
      description: description || "",
      type: selectedType.id
    };

    const res = await createDeleteHsn(data);

    if (res?.data?.status_code === 200 || res?.data?.status === true) {
      toast.success(res.data.message || "HSN created successfully!");
      setIsModal(true);
    } else {
      toast.error(res.data.message || "Failed to create HSN/SAC");
    }

    setIsLoading(false);
  };

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/procurement/hsn-list`);
  };

  return (
    <Layout title="Back to HSN/SAC List" isLoading={isLoading} isGoback={true}>
      <Fragment>
        <div className="card">
          <div className="card-header">Create HSN/SAC</div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <ConstantInput
                  label="HSN Name"
                  type="text"
                  value={hsnName}
                  handleChange={val => setHsnName(val)}
                  required
                  isStarRequired={true}
                />
              </div>

              <div className="col-md-6">
                <DropDownInput
                  label="Select GST"
                  data={gstList || []}
                  getIdValue={val => setSelectedGst(val)}
                  required
                  isStarRequired={true}
                />
              </div>

              <div className="col-md-6">
                <DropDownInput
                  label="Select Type"
                  data={[{ id: 'HSN', name: 'HSN' }, { id: 'SAC', name: 'SAC' }]}
                  getIdValue={val => setSelectedType(val)}
                  required
                  isStarRequired={true}
                />
              </div>

              <div className="col-md-6 mt-3">
                <ConstantInput
                  label="Description (Optional)"
                  type="text"
                  value={description}
                  handleChange={val => setDescription(val)}
                  required={false}
                  isStarRequired={false}
                />
              </div>

              <div className="col-md-12 mt-3">
                <Button onClick={handleSubmit}>Submit</Button>
              </div>
            </div>
          </div>
        </div>

        <ModalPop
          title="Success"
          show={isModal}
          handleModalHide={handleModalHide}
          keyboard
        >
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="success" />
            </div>
            <h5>HSN/SAC Created Successfully!</h5>
          </div>
        </ModalPop>
      </Fragment>
    </Layout>
  );
};

export default CreateHsn;